import i18next from 'i18next';

export const getLanguageOptions = () => {
    return [
        { label: i18next.t('Spanish'), value: 'es-mx' },
        { label: i18next.t('English'), value: 'en-us' },
    ];
};
